"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BANNER_TYPES = exports.UNIVERSAL = exports.TGK_SEARCH_PAGE_MOBILE = exports.TGK_SEARCH_PAGE = exports.SEARCH_PAGE_MOBILE = exports.SEARCH_PAGE = exports.MAIN_PAGE_MOBILE = exports.MAIN_PAGE = exports.BannerFileTypeEnum = void 0;
var BannerFileTypeEnum;
(function (BannerFileTypeEnum) {
    BannerFileTypeEnum["MAIN_PAGE"] = "main";
    BannerFileTypeEnum["MAIN_PAGE_MOBILE"] = "main_mobile";
    BannerFileTypeEnum["SEARCH_PAGE"] = "search";
    BannerFileTypeEnum["SEARCH_PAGE_MOBILE"] = "search_mobile";
    BannerFileTypeEnum["UNIVERSAL"] = "univ";
})(BannerFileTypeEnum = exports.BannerFileTypeEnum || (exports.BannerFileTypeEnum = {}));
exports.MAIN_PAGE = "main";
exports.MAIN_PAGE_MOBILE = "main_mobile";
exports.SEARCH_PAGE = "search";
exports.SEARCH_PAGE_MOBILE = "search_mobile";
exports.TGK_SEARCH_PAGE = "tgk_search";
exports.TGK_SEARCH_PAGE_MOBILE = "tgk_search_mobile";
exports.UNIVERSAL = "universal";
exports.BANNER_TYPES = [
    exports.MAIN_PAGE,
    exports.MAIN_PAGE_MOBILE,
    exports.SEARCH_PAGE,
    exports.SEARCH_PAGE_MOBILE,
    exports.TGK_SEARCH_PAGE,
    exports.TGK_SEARCH_PAGE_MOBILE,
    exports.UNIVERSAL
];
